module.exports = __webpack_public_path__ + "c7d1d58d731966a5e7dd937c2b0241cd.svg";